import React from "react";
import { Outlet } from "react-router-dom";
import Bars from "../bars/Bars";
import Sidebar from "../Sidebar";

import "./index.scss";

const Layout = () => {
  return (
    <>
      <div className="main-container">
        <Sidebar />
        <Bars />
        <div className="section">
          <div className="container">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
